import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const useNotificationStore = create(
  persist(
    (set, get) => ({
      notifications: [],
      unreadCount: 0,
      messagesUnreadCount: 0,

      // Ajouter une notification
      addNotification: (notification) => {
        set((state) => ({
          notifications: [
            { id: Date.now(), read: false, ...notification },
            ...state.notifications
          ],
          unreadCount: state.unreadCount + 1
        }))
      },

      // Marquer une notification comme lue
      markAsRead: (notificationId) => {
        set((state) => ({
          notifications: state.notifications.map((n) =>
            n.id === notificationId ? { ...n, read: true } : n
          ),
          unreadCount: Math.max(0, state.unreadCount - 1)
        }))
      },

      // Marquer toutes les notifications comme lues
      markAllAsRead: () => {
        set((state) => ({
          notifications: state.notifications.map((n) => ({ ...n, read: true })),
          unreadCount: 0
        }))
      },

      // Définir le nombre de messages non lus
      setMessagesUnreadCount: (count) => {
        set({ messagesUnreadCount: count })
      },

      // Incrémenter les messages non lus
      incrementMessagesUnread: () => {
        set((state) => ({
          messagesUnreadCount: state.messagesUnreadCount + 1
        }))
      },

      // Décrémenter les messages non lus
      decrementMessagesUnread: () => {
        set((state) => ({
          messagesUnreadCount: Math.max(0, state.messagesUnreadCount - 1)
        }))
      },

      // Réinitialiser les messages non lus
      resetMessagesUnread: () => {
        set({ messagesUnreadCount: 0 })
      },

      // Supprimer une notification
      removeNotification: (notificationId) => {
        set((state) => {
          const notification = state.notifications.find((n) => n.id === notificationId)
          return {
            notifications: state.notifications.filter((n) => n.id !== notificationId),
            unreadCount: notification && !notification.read 
              ? Math.max(0, state.unreadCount - 1)
              : state.unreadCount
          }
        })
      },

      // Effacer toutes les notifications
      clearNotifications: () => {
        set({ notifications: [], unreadCount: 0 })
      }
    }),
    {
      name: 'notification-storage',
      partialPersist: true
    }
  )
)

export default useNotificationStore
